module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Dedication-rw",
    attrs: {
      "epub:type": "frontmatter dedication",
      "id": "Dedication1"
    }
  }, [_c('div', {
    staticClass: "block-rw dedication-rw",
    attrs: {
      "id": "dedication1"
    }
  }, [_c('p', {
    staticClass: "ded-rw",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "p43"
    }
  }, [_c('span', [_c('span', [_c('em', [_vm._v("To my beautiful and talented daughter-in-law, Randi,")])])])]), _c('p', {
    staticClass: "ded-rw",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "p44"
    }
  }, [_c('span', [_c('span', [_c('em', [_vm._v("Who uses her skills to teach very special students.")])])])]), _c('p', {
    staticClass: "ded-rw",
    attrs: {
      "id": "p31"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "ded-rw",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "p46"
    }
  }, [_c('span', [_c('span', [_c('em', [_vm._v("And to Tom, my forever love.")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ecd317e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s003-Dedication-01.vue
// module id = 66
// module chunks = 0